import { render, staticRenderFns } from "./IncidentItem.vue?vue&type=template&id=1e5b7e95"
import script from "./IncidentItem.vue?vue&type=script&lang=js"
export * from "./IncidentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports